import { Component, Input } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';

@Component({
  selector: 'app-trip-card',
  templateUrl: './trip-card.component.html',
})
export class TripCardComponent {
  @Input({required: true, alias: 'tripData'}) trip: any;
  constructor(public readonly feUtil: FeUtil) {}

  protected getProgress(trip: any) {
    let totalLegs = trip?.legs?.length;
    let completedLegs = trip?.legs?.filter((leg: any) => leg?.status == 'completed').length;
    return Math.round((completedLegs / totalLegs) * 100);
  }
}
